import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { SelectProps } from 'antd/lib';
import * as React from 'react';
import './style.css';
import { Select } from 'antd';

export interface IEmrSelectProps
  extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'>,
    Omit<SelectProps, 'name'> {}

const EmrSelect: React.FC<IEmrSelectProps> = ({ disabled, field, name, labelProps = {}, ...rest }) => {
  return (
    <EmrFormItem field={field} name={name} initialValue={disabled ? undefined : field?.default} {...labelProps}>
      <Select
        disabled={disabled}
        placeholder={field?.placeholder}
        options={
          field?.extra?.options?.map((o: any) => ({
            label: <span style={{ color: o.color }}>{o.label}</span>,
            value: o.value,
          })) || field?.enum?.split(',').map((o: string) => ({ label: o, value: o?.trim() }))
        }
        className={'base-select w-full '}
        {...rest}
      />
    </EmrFormItem>
  );
};
export default EmrSelect;
